import { Users, MessageSquare } from 'lucide-react';
import { oneTouchBank } from '../../../data/OneTouchBank';
import { meetingHeroBank } from '../../../data/MeetingHeroBank';

export const CHAT_GAMES = {
  // --- MODULE 2: The One-Touch Rule (5-Scenario Loop) ---
  'slack-attack': {
    id: "game_slack_attack_v2", 
    
    // 1. THE BRIEFING (Pre-Game Context)
    preGameBriefing: {
        title: "The Notification Noise",
        script: "Listen up. In this environment, your reputation isn't built in big meetings; it’s built in the DMs. You are about to enter the 'Notification Zone.' Your bosses are drowning in noise—121 emails a day on average. Your mission: Get the info you need without becoming part of the noise. If you send a message that just says 'Hey'... you lose. Good luck.",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
    },

    // 2. SCENARIO INJECTION
    scenarios: oneTouchBank,
    winMessage: "Perfect execution across the board. The team appreciates the clarity.",
    
    // 3. FAILURE LOGIC (Tactical Interventions)
    failureLogic: {
        'fragmented': {
            title: "The One-Touch Rule",
            script: "Stop. You included a noise chip or fragmented the message. That forces the recipient to stop working and wait for you to type. That’s a penalty. The Fix: Use the One-Touch Rule. Combine your Context + Detail + Action into a single block.",
            videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        }
    }
  },

  // --- PART 5 (MEETING HERO) ---
  'game_meeting_hero': {
    id: 'game_meeting_hero',
    title: 'The Invisible Employee',
    bossAvatar: '📹', 
    bossName: 'Zoom Chat (All)',
    
    preGameBriefing: {
        title: "The Zoom Paradox",
        script: "In remote work, if you don't speak, you don't exist. But if you speak just to hear your own voice, you're annoying. The Mission: The meeting is ending. You haven't said a word. You have one chance to make an impact without being 'that guy'.",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
    },

    // 2. SCENARIO INJECTION
    scenarios: meetingHeroBank,
    winMessage: "Meeting adjourned. Good work."
  }
};